<template>
    <Form ref="info" :rules="innerRules" :model="info" inline>
        <FormItem prop="startDate">
            <DatePicker
                v-model="info.startDate"
                transfer
                type="date"
                clearable
                style="width: 160px"
                @on-change="onStartDateChange"
                :options="optionsStart"
            >
            </DatePicker>
        </FormItem>
        <span style="margin-right: 10px">至</span>
        <FormItem prop="endDate">
            <DatePicker
                v-model="info.endDate"
                transfer
                type="date"
                clearable
                style="width: 160px"
                @on-change="onEndDateChange"
                :options="optionsEnd"
            >
            </DatePicker>
        </FormItem>
        <check-tag-group
            style="display: inline-block"
            v-model="selectMode"
            color="primary"
            @on-change="onModeChagne"
            unpopulated
            :required="false"
        >
            <check-tag
                v-for="item in selectModeList"
                :name="item.id"
                :key="item.id"
            >
                {{ item.text }}
            </check-tag>
        </check-tag-group>
    </Form>
</template>
<script>
import { Field } from 'ivux'
import { type } from '_u/helper'
import dayjs from 'dayjs'

// 开始日期-结束日期 选择
export default {
    name: 'SeDatePicker',

    mixins: [Field],

    props: {
        // 开始时间
        startDate: {
            type: [Number, String, Date],
            default: () => new Date(),
        },
        // 结束时间
        endDate: {
            type: [Number, String, Date],
            default: '',
        },
        // @override
        populateType: {
            type: String,
            default: 'through',
        },
    },

    data() {
        return {
            info: {
                startDate: this.startDate,
                endDate: this.endDate,
            },
            selectModeList: [
                { id: 1, text: '1个月' },
                { id: 2, text: '2个月' },
                { id: 3, text: '3个月' },
                { id: 6, text: '半年' },
                { id: 12, text: '一年' },
            ],
            selectMode: [],
            optionsStart: {
                disabledDate: (date) => {
                    if (this.info.endDate) {
                        return (
                            date &&
                            date.valueOf() >= this.info.endDate.valueOf()
                        )
                    } else {
                        return false
                    }
                },
            },
            optionsEnd: {
                disabledDate: (date) => {
                    if (this.info.startDate) {
                        return (
                            date &&
                            date.valueOf() <= this.info.startDate.valueOf()
                        )
                    } else {
                        return false
                    }
                },
            },
        }
    },

    watch: {
        startDate(val) {
            this.info.startDate = val ? this.castToDate(val) : ''
        },
        endDate(val) {
            this.info.endDate = val ? this.castToDate(val) : ''
        },
    },

    computed: {
        innerRules() {
            return {
                startDate: [{ required: true, message: '开始日期必填' }],
                endDate: [
                    { required: true, message: '结束日期必填' },
                    { validator: this.checkEndDate },
                ],
            }
        },
    },

    created() {
        this.$watch(function(){
          return this.info.startDate
        }, function(){
          this.$emit('on-change', { ...this.info, name: 'startDate' })
        })
        this.$watch(function(){
          return this.info.endDate
        }, function(){
          this.$emit('on-change', { ...this.info, name: 'endDate' })
        })
    },

    methods: {
        onStartDateChange(val) {
            this.selectMode = []
        },

        onEndDateChange(val) {
            this.selectMode = []
        },

        onModeChagne(selecteds) {
            var curMode = selecteds[0]

            if (curMode && this.info.startDate) {
                let endDate = dayjs(this.info.startDate)
                    .add(curMode, 'month')
                    .toDate()
                endDate.setDate(endDate.getDate() - 1)
                this.info.endDate = endDate
                this.$nextTick(() => this.$refs.info.validate())
            }
        },

        castToDate(val) {
            var t = type(val)
            if (t == 'string') {
                return dayjs(val, 'YYYY-MM-DD').toDate()
            }

            if (t == 'number') {
                return dayjs(t).toDate
            }

            return val
        },

        checkEndDate(rule, value, callback, source, options) {
            if (source.startDate && value) {
                if (value.getTime() <= source.startDate.getTime()) {
                    return callback(new Error('截止时间不得早于开始时间'))
                }
            }

            callback()
        },
    },
}
</script>
<style lang="less" scoped></style>
